const eventBus = useEventBus()

import Splide from '@splidejs/splide';
import { useCustomGtm } from '~/composables/useEventTagManager';
import { useInsiderSdk } from '~/composables/insiderSdk';

interface IMiniCartResponse {
    success: boolean,
    html: string,
    datalayer?: any,
    item_name?: string,
    message?: string,
    insider_sdk: {
    item: [],
    currency: 'MYR'
  }
}

const changeQuantity = () => {
    const itemEls = Array.from(document.querySelectorAll('.quantity-button:not([disabled])'));

    itemEls.forEach((el) => {
        el.addEventListener("click", function (event) {
            const targetElement = event.target as HTMLElement;
            if (targetElement.closest('.quantity__container')) {
                const elItem = targetElement.closest('.quantity__container');

                if (elItem) {
                    const elInput = elItem.querySelector('input[name="mnc-quantity"]') as HTMLInputElement;

                    if (elInput) {
                        const cartItemKey = elInput.getAttribute('data-key') || '';
                        const maxQty = parseInt(elInput.getAttribute('max')) || 1;
                        let qty = parseInt(elInput.value) || 0;
                        let type='';

                        if (targetElement.classList.contains("quantity-button__minus")) {
                            qty = qty - 1;
                        }

                        if (targetElement.classList.contains("quantity-button__plus")) {
                            qty = qty + 1;
                            type = 'plus';
                        }

                        elInput.value = qty.toString();
                        showMiniCartOverlay();
                        actionChangeQuanity(cartItemKey, maxQty, type,qty);
                    }
                }
            }
        });
    })
}

const removeItem = () => {

    const itemEls = Array.from(document.querySelectorAll('.alt_remove_cart_button'));

    itemEls.forEach((el) => {
        el.addEventListener("click", function (event) {
            event.preventDefault();
            const targetElement = event.currentTarget as HTMLElement;
            if (targetElement.closest('.woocommerce-mini-cart-item')) {
                const elItem = targetElement.closest('.woocommerce-mini-cart-item');
                const itemName = targetElement.getAttribute('data-name') || '';
                // console.log('itemName', itemName);
                if (elItem) {
                    const itemId = elItem.getAttribute('data-id') || '';
                    showMiniCartOverlay();
                    actionRemoveItem(itemId);
                }
            }
        });
    })
}

const actionRemoveItem = async (item_id: string) => {
    const { trackRemoveCartFrom } = useCustomGtm();
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();
    console.log('start remove cart');

    try {
        const response = await $ajax.post<IMiniCartResponse>('wp-admin/admin-ajax.php', {
            action: 'alt_mini_cart_remove',
            item_id: item_id
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.success) {
            trackRemoveCartFrom(response.datalayer);
            if (typeof window.lxt !== 'undefined') {
                window.lxt('track', 'products_removed_from_cart', response.item_name);
            }

            eventCart(response.html, response.total);
            eventBus.emit('cart:update', 'remove');
           // getMiniCart();
            // insider SDK
             const {
                trackEventCart
            } = useInsiderSdk();

            const items = response?.insider_sdk['item'] || [];
            const currency = 'MYR';

            trackEventCart('insider_sdk_remove_from_cart','remove_from_cart',items,currency,'');
           // end insider SDK
        }
    } catch (err: any) {
        //console.log('err.respo nse', err);
        hideMiniCartOverlay();
        getMiniCart();
    }
}

const actionChangeQuanity = async (item_key: string, max_qty: number, type: string,value: number) => {
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();

    try {
        const response = await $ajax.post<IMiniCartResponse>('wp-admin/admin-ajax.php', {
            action: 'alt_mini_cart_quantity',
            item_key: item_key,
            max: max_qty,
            type: type,
            qty: value
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.success) {
            eventCart(response.html, response.total);
            eventBus.emit('cart:update', 'quantity');
           // getMiniCart();
            // remove ======= sdk
            // insider SDK
           
            if (response?.insider_sdk) {
            const items = response?.insider_sdk['item'] || [];
           
            if (items && items.id) {
                const {
                    trackEventCart
                } = useInsiderSdk();

                
                const currency = 'MYR';

                trackEventCart('insider_sdk_remove_from_cart','remove_from_cart',items,currency,'');
            }
            }
        }else{
            if (response.message) {
                alert(response.message);
            }
            getMiniCart();
            hideMiniCartOverlay(); 
        }
    } catch (err: any) {
        //console.log('err.response', err);
        hideMiniCartOverlay();
    }
}

/** Savillla - Coupon */
// Apply Coupon Click
const applyCouponMiniCart = () => {
    const applyBtn = document.getElementsByClassName('minicart-coupon__btn');
    const input = document.getElementById('minicart-coupon__input');
    var coupon_code = '';
    if (applyBtn[0]) {
        applyBtn[0].addEventListener("click", function (event) {

            if (input) {
                coupon_code = input.value;
            }
            if (coupon_code != '') {
                showMiniCartOverlay();
                actionApplyCoupon(coupon_code);
            } else {
                var couponNotice = document.querySelector('.coupon-notice');
                couponNotice.innerHTML = 'Please enter a coupon code';
                couponNotice.style.display = "block";
            }

        });
    }
};
// Apply Coupon Action
const actionApplyCoupon = async (code: String) => {
    //console.log('check ....');
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();

    try {
       // console.log('check 222222 ....');
        const response = await $ajax.post<IMiniCartResponse>('wp-admin/admin-ajax.php', {
            action: 'kts_mini_cart_apply_coupon',
            coupon_code: code,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.success) {
            eventCart(response.html, response.total);
            //showMiniCartOverlay();
            eventBus.emit('cart:update', 'apply_coupon');
           // getMiniCart();
           hideMiniCartOverlay();
        } else {
            //console.log('------- response false');
            if (response.success == false) {
                hideMiniCartOverlay();
                var couponNotice = document.querySelector('.coupon-notice');
                couponNotice.innerHTML = response.message;
                couponNotice.style.display = "block";

            }
        }
        //hideMiniCartOverlay();
    } catch (err: any) {
        hideMiniCartOverlay();
        console.log('err.response', err);
    }
};
// Remove Coupon Click
const removeCouponMiniCart = () => {
    const applyBtns = document.querySelectorAll('.remove-coupon');
    if (applyBtns) {
        applyBtns.forEach((el) => {
            el.addEventListener("click", function (event) {
                event.preventDefault();
                const couponHref = el.getAttribute('href') || '';
                const paramArr = couponHref.split('&');
                let coupon_code = '';
                for (const param of paramArr) {
                    const [key, value] = param.split('=');

                    if (key === 'coupon') {
                        coupon_code = value;
                        break;
                    }
                }
                showMiniCartOverlay();
                actionRemoveCoupon(coupon_code);
            });
        });
    }
};
// Remove Coupon Action
const actionRemoveCoupon = async (code: String) => {
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();

    try {
        const response = await $ajax.post<IMiniCartResponse>('wp-admin/admin-ajax.php', {
            action: 'kts_mini_cart_remove_coupon',
            coupon_code: code,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.success) {
            eventCart(response.html, response.total);
            showMiniCartOverlay();
            eventBus.emit('cart:update', 'remove_coupon');
            //getMiniCart();
        }

        hideMiniCartOverlay();
    } catch (err: any) {
        //console.log('err.response', err);
        hideMiniCartOverlay();
    }
};
/** End Coupon */
/** Savillla - GWP */
const convertGWPToSplide = () => {
    const _splide = document.querySelector('.oaps-gwp__container');
    const _splideTrack = document.querySelector('.oaps-gwp__carousel');
    const _splideList = document.querySelector('.oaps-gwp__carousel-items');
    const _splideslides = document.querySelectorAll('.oaps-gwp__carousel-item');
    if (_splide instanceof HTMLElement && _splideTrack instanceof HTMLElement && _splideList instanceof HTMLElement) {
        if (_splide !== null && _splideTrack !== null && _splideList !== null && _splideslides !== null) {
            _splide.classList.add('splide');
            _splide.setAttribute('ref', 'miniCartGWP');
            _splideTrack.classList.add('splide__track');
            _splideList.classList.add('splide__list');
            _splideslides.forEach((item: Element) => {
                if (item instanceof HTMLElement) {
                    item.classList.add('splide__slide')
                }
            });
            initGWPSplide();
        }
    }
};

const initGWPSplide = () => {
    const _splideGWP = document.querySelector('.oaps-gwp__container');
    if (_splideGWP) {
        const splideGWP = new Splide(_splideGWP, {
            type: 'loop',
            arrows: true,
            pagination: false,
            perPage: 2,
            perMove: 1,
            gap: "20px",
            fixedWidth: '70%',
            speed: '2000',
            snap: true,
            mediaQuery: "max",
            breakpoints: {
                600: {
                    perPage: 1,
                    fixedWidth: '100%',
                }
            },
            classes: {
                prev: 'splide__arrow--prev gwp__arrow-prev',
                next: 'splide__arrow--next gwp__arrow-next',
            }
        });
        splideGWP.on("mounted", function () {
            const totalSlides = splideGWP.Components.Elements.slides.length;
            if (totalSlides <= 1) {
                splideGWP.options = { type: 'slide' };
                splideGWP.refresh();
                const gwpArrows = document.querySelector('.oaps-gwp__carousel-arrows');
                if (gwpArrows) {
                    gwpArrows.style.display = 'none';
                }
            }
            if (totalSlides == 0) {
                _splideGWP.parentElement.classList.add('hidden');
            }
        });
        splideGWP.mount();
    }
};
const initGWPVariationDropdown = () => {
    const buttonEl = document.querySelectorAll('.oaps-gwp-select-dropdown__button');
    buttonEl.forEach((item: Element, index: number) => {
        if (item instanceof HTMLElement) {
            item.addEventListener("click", function (event) {
                event.preventDefault();
                item.nextElementSibling?.classList.toggle('active');
            });
        }
    });
}
const initGWPSelectVariation = () => {
    const variationEls = document.querySelectorAll('.oaps-gwp-select-dropdown__list-item');

    variationEls.forEach((item: Element) => {
        if (item instanceof HTMLElement) {
            item.addEventListener("click", function (event) {
                event.preventDefault();
                let variation_id = item.getAttribute("data-value");

                var parentEl = item.parentElement;
                if (parentEl) {
                    var dropdownButton = parentEl.previousElementSibling;
                    var dropdownText = parentEl.previousElementSibling?.firstElementChild;
                    if (dropdownButton) {
                        dropdownButton.setAttribute('data-value', variation_id);
                        dropdownText.innerHTML = item.innerHTML;
                    }
                    parentEl.classList.remove('active');
                    const grandparent = parentEl.parentElement.parentElement;
                    const nextSibling = grandparent?.nextElementSibling;
                    if (nextSibling) {
                        nextSibling.setAttribute('data-variation-id', variation_id);
                    }
                }
            });
        }
    });
}
const initGWPArrows = () => {
    const prevEl = document.querySelector('.oaps-gwp__carousel-arrow--prev');
    const nextEl = document.querySelector('.oaps-gwp__carousel-arrow--next');

    if (prevEl) {
        const splidePrevEl = document.querySelector('.gwp__arrow-prev');
        prevEl.addEventListener("click", function (event) {
            event.preventDefault();
            if (splidePrevEl) {
                splidePrevEl.click();
            }
        });
    }

    if (nextEl) {
        const splideNextEl = document.querySelector('.gwp__arrow-next');
        nextEl.addEventListener("click", function (event) {
            event.preventDefault();
            if (splideNextEl) {
                splideNextEl.click();
            }
        });
    }
};
const gwpAlreadyInProcess = ref<boolean>(false);
const initGWPAddToCart = () => {
    if (gwpAlreadyInProcess.value == true) {
        return false;
    }
    gwpAlreadyInProcess.value = false;

    const atcBtns = document.querySelectorAll('.oaps-gwp__item-atc');
    atcBtns.forEach((item: Element) => {
        if (item instanceof HTMLElement) {
            item.addEventListener('click', function (event) {
                event.preventDefault();
                var product_id = item.getAttribute('data-product-id');
                var variation_id = item.getAttribute('data-variation-id');
                var product_qty = 1;
                var rule_id = item.getAttribute('data-rule-id');
                var rule_title = item.getAttribute('data-rule-title');
                var offer_condition = item.getAttribute('data-offer-condition');
                console.log('----- offer_condition: ',offer_condition);
                if (variation_id == '') {
                    alert("Please choose a variation");
                    gwpAlreadyInProcess.value = false;
                } else {
                    item.classList.add('oaps-disable');
                    showMiniCartOverlay();
                    actionGWPAddToCart(product_id, variation_id, product_qty, rule_id, rule_title,offer_condition, item);
                }
            });
        }
    });

}
const actionGWPAddToCart = async (p_id: number, v_id: Number, qty: Number, r_id: Number, r_title: String, offer_condition:String,atcBtn: HTMLElement) => {
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();

    try {
        const response = await $ajax.post<IMiniCartResponse>('wp-admin/admin-ajax.php', {
            action: 'kts_mini_cart_gwp_add_to_cart',
            product_id: p_id,
            variation_id: v_id,
            product_qty: qty,
            rule_id: r_id,
            rule_title: r_title,
            offer_condition: offer_condition
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.success) {
            eventCart(response.html, response.total);
            eventBus.emit('cart:update', 'gwp_added');
            //getMiniCart();
            gwpAlreadyInProcess.value = false;
            if (atcBtn) {
                atcBtn.classList.remove('oaps-disable');
            }
            // PWP to cart ======= sdk
            // insider SDK
            
            if (response?.insider_sdk) {
            
            const items = response?.insider_sdk['item'] || [];
            if (items && items?.id) {
                const {
                    trackEventCart
                } = useInsiderSdk();
                const currency = 'MYR';
                trackEventCart('insider_sdk_add_to_cart','add_to_cart',items,currency,'');
            }

        }
        // end // insider SDK
        }
        hideMiniCartOverlay();
    } catch (err: any) {
        gwpAlreadyInProcess.value = false;
        //console.log('err.response', err);
        if (atcBtn) {
            atcBtn.classList.remove('oaps-disable');
        }
        hideMiniCartOverlay();
    }
};
/** Savillla - PWP */
const convertPWPToSplide = () => {
    const _splide = document.querySelector('.oaps-pwp__container');
    const _splideTrack = document.querySelector('.oaps-pwp__carousel');
    const _splideList = document.querySelector('.oaps-pwp__carousel-items');
    const _splideslides = document.querySelectorAll('.oaps-pwp__carousel-item');

    if (_splide instanceof HTMLElement && _splideTrack instanceof HTMLElement && _splideList instanceof HTMLElement) {
        if (_splide !== null && _splideTrack !== null && _splideList !== null && _splideslides !== null) {
            _splide.classList.add('splide');
            _splide.setAttribute('ref', 'miniCartGWP');
            _splideTrack.classList.add('splide__track');
            _splideList.classList.add('splide__list');
            _splideslides.forEach((item: Element) => {
                if (item instanceof HTMLElement) {
                    item.classList.add('splide__slide')
                }
            });
            initPWPSplide();
        }
    }
    // console.log('oaps-pwp__carousel-item', _splideslides);
    // console.log('splide_lenght', _splideslides.length);
    if(_splideslides.length <= 1){
        const pwpArrows = document.querySelector('.oaps-pwp__carousel-arrows');
        if (pwpArrows) {
            pwpArrows.style.display = 'none';
        }
    }
};
const initPWPSplide = () => {
    const _splidePWP = document.querySelector('.oaps-pwp__container');
    if (_splidePWP) {
        const splidePWP = new Splide(_splidePWP, {
            type: 'loop',
            arrows: true,
            pagination: false,
            perPage: 2,
            perMove: 1,
            gap: "20px",
            fixedWidth: '70%',
            speed: '2000',
            snap: true,
            mediaQuery: "max",
            breakpoints: {
                600: {
                    perPage: 1,
                    fixedWidth: '100%',
                }
            },
            classes: {
                prev: 'splide__arrow--prev pwp__arrow-prev',
                next: 'splide__arrow--next pwp__arrow-next',
            }
        });
        splidePWP.on("mounted", function () {
            const totalSlides = splidePWP.Components.Elements.slides.length;
            if (totalSlides <= 1) {
                splidePWP.options = { type: 'slide' };
                splidePWP.refresh();
                const pwpArrows = document.querySelector('.oaps-pwp__carousel-arrows');
                if (pwpArrows) {
                    pwpArrows.style.display = 'none';
                }
            }
        });
        splidePWP.mount();
    }
}
const initPWPVariationDropdown = () => {
    const buttonEl = document.querySelectorAll('.oaps-pwp-select-dropdown__button');
    buttonEl.forEach((item: Element, index: number) => {
        if (item instanceof HTMLElement) {
            item.addEventListener("click", function (event) {
                event.preventDefault();
                item.classList.toggle('active');
                item.nextElementSibling?.classList.toggle('active');
            });
        }
    });
}
const initPWPSelectVariation = () => {
    const variationEls = document.querySelectorAll('.oaps-pwp-select-dropdown__list-item');

    variationEls.forEach((item: Element) => {
        if (item instanceof HTMLElement) {
            item.addEventListener("click", function (event) {
                event.preventDefault();
                let variation_id = item.getAttribute("data-value");
                let attributes = item.getAttribute("data-attributes");
                var parentEl = item.parentElement;
                if (parentEl) {
                    var dropdownButton = parentEl.previousElementSibling;
                    var dropdownText = parentEl.previousElementSibling?.firstElementChild;
                    if (dropdownButton) {
                        dropdownButton.setAttribute('data-value', variation_id);
                        dropdownText.innerHTML = item.innerHTML;
                    }
                    parentEl.classList.remove('active');
                    const grandparent = parentEl.parentElement.parentElement;
                    const nextSibling = grandparent?.nextElementSibling;
                    if (nextSibling) {
                        nextSibling.setAttribute('data-variation-id', variation_id);
                        nextSibling.setAttribute('data-attributes', attributes);
                    }
                    var newPrice = item.getAttribute("data-new-price") ?? '';
                    item.closest('.oaps-pwp__item-detail')?.querySelector(".oaps-pwp__price")?.setAttribute("data-price", newPrice);
                    var priceSelector = ".oaps-pwp__price--" + variation_id;
                    var variationPrice = document.querySelector(priceSelector).innerHTML;
                    grandparent.parentElement.previousElementSibling.firstElementChild.innerHTML = variationPrice;
                }
            });
        }
    });
}
const initPWPArrows = () => {
    const prevEl = document.querySelector('.oaps-pwp__carousel-arrow--prev');
    const nextEl = document.querySelector('.oaps-pwp__carousel-arrow--next');

    if (prevEl) {
        const splidePrevEl = document.querySelector('.pwp__arrow-prev');
        prevEl.addEventListener("click", function (event) {
            event.preventDefault();
            if (splidePrevEl) {
                splidePrevEl.click();
            }
        });
    }

    if (nextEl) {
        const splideNextEl = document.querySelector('.pwp__arrow-next');
        nextEl.addEventListener("click", function (event) {
            event.preventDefault();
            if (splideNextEl) {
                splideNextEl.click();
            }
        });
    }
};
const pwpAlreadyInProcess = ref<boolean>(false);
const initPWPAddToCart = () => {
    if (pwpAlreadyInProcess.value == true) {
    }
    pwpAlreadyInProcess.value = false;

    const atcBtns = document.querySelectorAll('.oaps-pwp__item-atc');

    atcBtns.forEach((item: Element) => {
        if (item instanceof HTMLElement) {
            item.addEventListener('click', function (event) {
                event.preventDefault();
                var product_id = item.getAttribute('data-product-id');
                var variation_id = item.getAttribute('data-variation-id');
                var product_qty = 1;
                var attributes = item.getAttribute('data-attributes');
                var rule_id = item.getAttribute('data-rule-id');
                var rule_title = item.getAttribute('data-rule-title');
                 var offer_condition = item.getAttribute('data-offer-condition');
                if (variation_id == '') {
                    alert("Please choose a variation");
                    pwpAlreadyInProcess.value = false;
                } else {
                    item.classList.add('oaps-disable');
                    showMiniCartOverlay();
                    actionPWPAddToCart(product_id, variation_id, product_qty, attributes, rule_id, rule_title, offer_condition,item);
                }
            });
        }
    });

}
const actionPWPAddToCart = async (p_id: Number, v_id: Number, qty: Number, attr: string, r_id: Number, r_title: String,offer_condition: String, atcBtn: HTMLElement) => {
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();
    var product_sku = atcBtn.getAttribute('data-sku') ?? '';
    var product_name = atcBtn.getAttribute('data-name') ?? '';
    var stock_status = atcBtn.getAttribute('data-stockstatus') ?? 'outofstock';
    var stock_level = Number(atcBtn.getAttribute('data-stocklevel'));
    var categories = atcBtn.getAttribute('data-category') ?? '';
    var product_price = atcBtn.closest('.oaps-pwp__item-detail')?.querySelector(".oaps-pwp__price")?.getAttribute("data-price") ?? '';
    var dataLayer = atcBtn.getAttribute('data-layer');
    if( dataLayer ) {
        dataLayer = JSON.parse(dataLayer);
    }

    var free_chain = atcBtn.getAttribute('data-free-chain');

    let chain_options = null;
    let custom_group_id = '';

    if (free_chain) {
        try {
            chain_options = JSON.parse(free_chain);
            custom_group_id = chain_options.custom_group_id || '';
        } catch (error) {
            console.error('Invalid data-free-chain:', free_chain, error);
        }
    }

    try {
        const response = await $ajax.post<IMiniCartResponse>('wp-admin/admin-ajax.php', {
            action: 'kts_mini_cart_pwp_add_to_cart',
            product_id: p_id,
            variation_id: v_id,
            product_qty: qty,
            attributes: attr,
            rule_id: r_id,
            rule_title: r_title,
            chain_options: {
                free_product_id: chain_options?.free_product_id || 0,
                product_id: '',
                is_added: false,
            },
            is_attached: true,
            custom_group_id: custom_group_id,
            offer_condition: offer_condition
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });



        if (response.success) {
            eventCart(response.html, response.total);
            eventBus.emit('cart:update', 'pwp_added');
            //getMiniCart();


            const {
                trackCustom
            } = useCustomGtm();


            //console.log('dataLayer', dataLayer);

            trackCustom(dataLayer);
            if (atcBtn) {
                atcBtn.classList.remove('oaps-disable');
            }

             // PWP to cart ======= sdk
            // insider SDK
          
            if (response?.insider_sdk) {
            const items = response?.insider_sdk['item'] || [];
            if (items && items.id) {
                const {
                    trackEventCart
                } = useInsiderSdk();

                
                const currency = response?.insider_sdk['currency'] || 'MYR';

                trackEventCart('insider_sdk_add_to_cart','add_to_cart',items,currency,'');
            }

        }
         // end // insider SDK
        }

        pwpAlreadyInProcess.value = false;
    } catch (err: any) {
        if (atcBtn) {
            atcBtn.classList.remove('oaps-disable');
        }
        pwpAlreadyInProcess.value = false;
        //console.log('err.response', err);
        hideMiniCartOverlay();
    }
};
const showMiniCartOverlay = () => {
    const overlayWrapper = document.querySelector('.oaps-gwp-overlay-loading');
    if (overlayWrapper) {
        if (!overlayWrapper.classList.contains('loading')) {
            overlayWrapper.classList.add('loading');
        }
    }
}
const hideMiniCartOverlay = () => {
    const overlayWrapper = document.querySelector('.oaps-gwp-overlay-loading');
    if (overlayWrapper) {
        if (overlayWrapper.classList.contains('loading')) {
            overlayWrapper.classList.remove('loading');
        }
    }
}

const closePopup = () => {
    const closeEl = document.getElementsByClassName('minicart-close');
    if (closeEl[0]) {
        closeEl[0].addEventListener("click", function (event) {
            const miniCartEl = document.getElementById('alt-minicart') as HTMLElement;
            if (miniCartEl) {
                miniCartEl.click();
            }
        });
    }
}

/* ---------------------------------------------------------------- */
/* emma coupon bypass */
const showPopupCoupon = () => {
    const body = document.querySelector('body');
    const infor_error_discount = document.querySelector('.custom_mini_cart .coupon-notice');
    if (!document.body.classList.contains('woocommerce-checkout')) {
        const showPopupBtn = document.querySelector(".popup-coupon__select-coupon");
        const closePopupDiscount = document.querySelector(".popup-coupon--close-form .btn-x");
        if (showPopupBtn) {
            showPopupBtn.addEventListener("click", function (event) {
                const couponPopupWrapper = event.target.closest(".popup-coupon").querySelector(".popup-coupon--wrapper");

                if (couponPopupWrapper) {
                    couponPopupWrapper.classList.add("active");
                    body!.style.overflowY = 'hidden';
                }
                if (infor_error_discount) {
                    infor_error_discount.style.display = 'none';
                }
            });
        } else {
            // console.log("Element with class 'popup-coupon__select-coupon' not found.");
        }

        if (closePopupDiscount) {
            closePopupDiscount.addEventListener("click", function (event) {
                const couponPopupWrapper = event.target.closest(".popup-coupon").querySelector(".popup-coupon--wrapper");

                if (couponPopupWrapper) {
                    couponPopupWrapper.classList.remove("active");
                    body!.style.overflowY = 'hidden';
                }
            });
        }

    } else {
        const showPopupBtn = document.querySelectorAll(".popup-coupon__select-coupon");
        if (showPopupBtn.length > 0) {
            showPopupBtn.forEach((item) => {
                item.addEventListener("click", function (event) {
                    const couponPopupWrapper = document.querySelector(".popup-coupon--wrapper");
                    if (couponPopupWrapper)
                        document.querySelector(".popup-coupon--wrapper").classList.add("active");
                        body!.style.overflowY = 'auto';
                });
            });
        }
    }
}


const closeCouponPopup = () => {
    const showPopupBtn = document.querySelector(".popup-coupon--close-form span");
    const body = document.querySelector('body');
    if (showPopupBtn) {
        showPopupBtn.addEventListener("click", function (event) {
            if (!document.body.classList.contains('woocommerce-checkout')) {
                const couponPopupWrapper = event.target.closest(".popup-coupon").querySelector(".popup-coupon--wrapper");
                if (couponPopupWrapper) {
                    couponPopupWrapper.classList.remove("active");
                    body!.style.overflowY = 'auto';
                    // if (!document.body.classList.contains('woocommerce-checkout')) {
                    //     couponPopupWrapper.classList.remove("active");
                    // } else {
                    //     couponPopupWrapper.style.display = "none";
                    // }
                }
            } else {
                document.querySelector(".popup-coupon--wrapper").classList.remove("active");
                const body = document.querySelector('body');
            }
        });
    } else {
        // console.log("Element with class 'popup-coupon__select-coupon' not found.");
    }
}

const chooseCouponPopup = () => {
    const couponSelect = document.querySelectorAll(".popup-coupon--input");
    const popupCouponWrapper = document.querySelector(".popup-coupon--wrapper");
    let max = popupCouponWrapper ? popupCouponWrapper.getAttribute("data-max") : 0;
    if (couponSelect) {
        couponSelect.forEach(function (item, index) {
            item.addEventListener("change", function (event) {
                // console.log('change select couponm');

                const dataVidi = item.getAttribute("data-indiv");
                const dataType = item.getAttribute("data-type");
                if (item.checked) {

                    if (dataVidi == 'individual') {
                        couponSelect.forEach(function (item1, item1Index) {
                            if (!item1.closest(".popup-coupon--item").classList.contains("applied")) {
                                const typeItem = item1.getAttribute("data-type");
                                const dataVidi2 = item1.getAttribute("data-indiv");
                                if (dataVidi2 != 'individual' && typeItem == 'normal') {
                                    item1.checked = false;
                                }
                                if (dataVidi2 == 'individual' && typeItem == 'normal' && index != item1Index) {
                                    item1.checked = false;

                                }
                            }
                        });

                    } else {
                        couponSelect.forEach(function (item1, item1Index) {
                            if (!item1.closest(".popup-coupon--item").classList.contains("applied")) {
                                const typeItem = item1.getAttribute("data-type");
                                const dataVidi2 = item1.getAttribute("data-indiv");
                                if (dataVidi2 == 'individual' && typeItem == 'normal' && dataVidi == 'nonceindividual') {
                                    item1.checked = false;
                                }
                            }
                        });
                    }
                }
                unCheckOrCheckedItem(couponSelect, max);
            });
        });
    }
}


const unCheckOrCheckedItem = (couponSelect, max) => {
    const itemsChecked = document.querySelectorAll(".popup-coupon--input:checked");
    var j = itemsChecked.length;

    if (j >= max) {
        couponSelect.forEach(function (item1) {
            const parentElement = item1.closest(".popup-coupon--item");
            if (!parentElement.classList.contains("applied")) {
                if (!item1.checked) {
                    parentElement.classList.add("disabled");
                    //item1.checked = false;
                } else {
                    parentElement.classList.remove("disabled");
                }
            }
        });
    } else {
        let indivi = false;
        itemsChecked.forEach(function (item1) {
            if (item1.getAttribute("data-indiv") == 'individual') indivi = true;
        });
        if (indivi) {
            couponSelect.forEach(function (item1) {

                //nonceindividual
                const individualType = item1.getAttribute("data-indiv");
                const parentElement = item1.closest(".popup-coupon--item");
                if (!parentElement.classList.contains("applied")) {
                    if (!item1.checked) {
                        if (individualType == "nonceindividual") {
                            item1.checked = false;
                            // parentElement.classList.add("disabled");
                        } else {
                            // item1.checked = false;
                            parentElement.classList.remove("disabled");
                        }
                    }
                }
            });
        } else {
            couponSelect.forEach(function (item1) {
                const parentElement = item1.closest(".popup-coupon--item");
                if (!parentElement.classList.contains("applied")) {
                    if (!item1.checked) {
                        //item1.checked = false;
                        parentElement.classList.remove("disabled");
                    }
                }
            });
        }
    }
 const applyButton = document.getElementById("couponApply");


    if (applyButton) {
     if (j > 0 ) {
        applyButton.classList.remove('disabled');
    } else {
        applyButton.classList.add('disabled');
    }
    }
};

const applyCouponPopup = async () => {
    const { $ajax } = useNuxtApp();
    const applyButton = document.getElementById("couponApply");
    if (!applyButton) return;

    applyButton.addEventListener("click", async function (event) {
        event.preventDefault();

        let isMinicart = '';
        if (!document.body.classList.contains('woocommerce-cart') && !document.body.classList.contains('woocommerce-checkout')) {
            isMinicart = 'isMinicart';
        }

        const coupons = document.querySelectorAll<HTMLInputElement>(".popup-coupon--input");
        const selectedValues: string[] = [];
        coupons.forEach(function (checkbox) {
            if (checkbox.checked && checkbox.value !== '') {
                selectedValues.push(checkbox.value);
            }
        });

        const selectedValuesString = selectedValues.join(',');
        if (selectedValuesString === '') {
            alert("Please select the coupon");
            return;
        }

        applyButton.classList.add("loading");
        try {
            const response = await $ajax.post<IMiniCartResponse>('wp-admin/admin-ajax.php', {
                action: "emm_mini_cart_apply_coupon_popup",
                coupon_codes: selectedValuesString,
                isMinicart: isMinicart
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.success) {
                const couponWrapper = document.querySelector<HTMLElement>(".popup-coupon--wrapper");
                if (couponWrapper) {
                    couponWrapper.style.display = "none";
                }

                const updateCartButton = document.querySelector<HTMLButtonElement>('button[name="update_cart"]');
                if (updateCartButton) {
                    updateCartButton.removeAttribute('disabled');
                    updateCartButton.click();
                } else if (isMinicart !== '') {
                    eventCart(response.html, response.total);
                    eventBus.emit('cart:update', 'apply_coupon_popup');
                }
            } else {
                alert(response.message);
            }
        } catch (err) {
            //console.log('err.response', err);
        } finally {
            applyButton.classList.remove("loading");
            hideMiniCartOverlay();
        }
    });
};

/* end emma coupon bypass */

export const eventCart = (html: string, total = 0) => {
    const wooStore = useWooStore();
    const minicartEl = document.getElementsByClassName('alt-minicart-wrapper');
    if (minicartEl[0]) {
        minicartEl[0].innerHTML = html;
        closePopup();
        removeItem();
        changeQuantity();
        applyCouponMiniCart();
        removeCouponMiniCart();

        convertGWPToSplide();
        initGWPVariationDropdown();
        initGWPArrows();
        initGWPSelectVariation();
        initGWPAddToCart();

        convertPWPToSplide();
        initPWPVariationDropdown();
        initPWPArrows();
        initPWPSelectVariation();
        initPWPAddToCart();

        /* emma coupon bypass */
        closeCouponPopup();
        showPopupCoupon();

        chooseCouponPopup();

        applyCouponPopup();
         /* end emma coupon bypass */

        wooStore.setCartTotal(total);
    }
}



export const toggleMiniCart = (event: Event) => {
    //console.log('show mini cart');
    const targetElement = event.target as HTMLElement;
    const miniCartEl = document.getElementById("alt-minicart");
    if (miniCartEl && targetElement.closest('.alt-header-icons-cart') != null) {
        event.preventDefault();
        miniCartEl.classList.add('active');
        document.body.classList.add('active_mini_cart');
        hideLiveChat(true);
        document.body.style.overflowY = 'hidden';
        const customEvent = new CustomEvent('toggleMiniCart', {
            detail: {
                'open': true
            }
        });
        // insider sdk
       // console.log('---- open 222')
         getInforCartToDataLayer(true);
        // end insider sdk

        document.dispatchEvent(customEvent);
         /* emma coupon bypass */
        // closeCouponPopup();
        // showPopupCoupon();

        // chooseCouponPopup();

        // applyCouponPopup();
         /* end emma coupon bypass */
    }

    if (targetElement.id === 'alt-minicart' && !targetElement.closest('.alt-minicart-wrapper') || targetElement.classList.contains('minicart-close')) {
        event.preventDefault();
        //emit('toggle-minicart');
        if (miniCartEl) {
            let isClose = false;
            if (targetElement.classList.contains("minicart-close")) {
                miniCartEl.classList.remove('active');
                hideLiveChat(false);
                isClose = true;
                document.body.style.overflowY = 'auto';
                document.body.classList.remove('active_mini_cart');
            } else {
                miniCartEl.classList.toggle('active');
                if (miniCartEl.classList.contains("active")) {
                    hideLiveChat(true);
                } else {
                    hideLiveChat(false);
                    isClose = true;
                    document.body.style.overflowY = 'auto';
                    document.body.classList.remove('active_mini_cart');

                }
            }

            const customEvent = new CustomEvent('toggleMiniCart', {
                detail: {
                    'close': isClose
                }
            });

            document.dispatchEvent(customEvent);
        }
    }

    if (targetElement.classList.contains('alt_remove_cart_button') || targetElement.classList.contains('quantity-button') || targetElement.classList.contains('remove-coupon')) {
        // console.log('exclude');
        event.preventDefault();
    }
}
const hideLiveChat = (hide: boolean) => {
    const liveChat = document.getElementById('chat-widget-container');
    if (liveChat && hide) {
        liveChat.style.display = 'none';
    } else if (liveChat && !hide) {
        liveChat.style.display = 'block';
    }
    // Whatsapp
    const whatsapp = document.getElementById('qlwapp');
    if (whatsapp && hide) {
        whatsapp.style.display = 'none';
    } else if (whatsapp && !hide) {
        whatsapp.style.display = 'block';
    }
}
const altAjaxPost = async (url, data) => {
    const { $ajax } = useNuxtApp();

    try {
        return await $ajax.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } catch (err) {
        //console.log('err.response', err);
        throw err;
    }
}

export const getTotalCart = async () => {
    const { $ajax } = useNuxtApp();
    const wooStore = useWooStore();
    const requested = useState<boolean>('cart-total-requested', () => false);
    if (requested.value) return;
    requested.value = true;

    const sessionId = wooStore.wcId;
    let cartWasUpdated = false;
    const stopWatching = wooStore.$onAction(({ name }) => {
        if (name === 'setCartTotal') cartWasUpdated = true;
    });

    try {
        const response = await $ajax.get<
            { success: boolean; total: number },
            { success: boolean; total: number }
        >('wp-admin/admin-ajax.php?action=alt_cart_total', { timeout: 5000 });

        // Preserve a newer count supplied by a cart update during this request.
        if (response.success && !cartWasUpdated && wooStore.wcId === sessionId
            && Number.isSafeInteger(response.total) && response.total >= 0) {
            wooStore.setCartTotal(response.total);
        }
    } catch {
        // Keep the current count without loading mini-cart HTML as a fallback.
    } finally {
        stopWatching();
    }
};

export const getMiniCart = async () => {
    showMiniCartOverlay();
    const { $ajax } = useNuxtApp();

    try {
        const response = await $ajax.get<IMiniCartResponse>('wp-admin/admin-ajax.php?action=alt_mini_cart');
        if (response.success) {
            eventCart(response.html, response.total);
            eventBus.emit('cart:minicart:update', response);
            hideMiniCartOverlay();
           
            // Dispatch get Mini Cart event
            const miniCartEvent = new CustomEvent('ktsMiniCartUpdated', { detail: response });
            document.dispatchEvent(miniCartEvent);
        }

    } catch (err: any) {
        //console.log('err.response', err);
    }
}




export const actionPopupVoucher = () => {
/* emma coupon bypass */
        //closeCouponPopup();
       // showPopupCoupon();
        chooseCouponPopup();
        applyCouponPopup();
         /* end emma coupon bypass */
}

export const getInforCartToDataLayer = async (is_sdk?: boolean) => {
  const { $ajax } = useNuxtApp();
  
  try {
    // const response = await $ajax.post<CartResponse>('wp-admin/admin-ajax.php', {
    //   action: 'get_cart_info'
    // });
     const response = await $ajax.get<IMiniCartResponse>('wp-admin/admin-ajax.php?action=get_cart_info');

    if (response.success && response.data) {
        //console.log('---- insider cart:',response.data);
     
      const isEmpty = response.data.is_empty;
      
      
      
      // Data Format for Insider DataLayer
      const insiderDataLayer = {
        event: "insider_basket_event",
        insider_basket: response.data.insider_basket
      };

      // Push to DataLayer theo format Insider
      if (typeof window !== 'undefined' && isEmpty === false) {
        window.dataLayer = window.dataLayer || [];
        
        if (is_sdk) {
             const wooStore = useWooStore();
                const {
                trackInsiderSdkEvent
                } = useInsiderSdk();

                 const shipping = response.data.totals.shipping;

                const dataSdkCart = {
                    "shipping_cost": parseInt(shipping) > 0 ? parseInt(shipping) : 0,
                    "total": response.data.totals.total,
                    "items":response.data.insider_sdk
                   }

                trackInsiderSdkEvent(
                  'insider_sdk_cart',
                  'cart',
                  response.data?.currency || 'MYR',
                  { insider_cart_value: dataSdkCart }
                );

        
        } else {
            window.dataLayer.push(insiderDataLayer);
        }
 
        
      }

      return {
        success: true,
        data: response.data,
        insiderDataLayer: insiderDataLayer,
        insider_sdk: response.data.insider_sdk
      };
    } else {
      return {
        success: false,
        data: null,
        error: response.message || 'Failed to get cart information'
      };
    }
  } catch (err: any) {
    console.error('Error getting cart info:', err);
    return {
      success: false,
      data: null,
      error: err.response?.data?.message || err.message || 'Unknown error occurred'
    };
  }
};
